"use client";

import { createContext, useContext } from "react";

export type LayoutDirection = "TB" | "LR";

export const DirectionContext = createContext<LayoutDirection>("TB");

export function useDirection(): LayoutDirection {
  return useContext(DirectionContext);
}
